import { combineReducers } from "redux";
import login from "./login/login-reducer";
import snackbar from "./snackbar/snackbar_reducer";
import loader from "./loader/loader_reducer";
import businessUnit from "./businessUnit/businessUnitReducer";
import frameworks from "./frameworks/frameworkReducer";
import topic from "./topics/topicReducer";
import basicInfo from "./basicinfoReducer/basicinfoReducer";
import esgStrategy from "./esgStrategy/esgStrategyReducer";
import fieldData from "./fieldData/fieldDataReducer";
import surveyListing from "./surveyListing/surveyListingReducer";
import reportlisting from "./reportListing/reportListingReducer";
import generalSettings from "./generalSettings/generalSettingsReducer";
import comments from "./comments/commentsReducer";
import { loadingBarReducer } from "react-redux-loading-bar";
import layout from "./layout/layoutReducer";

import user from "./auth/userReducer";
import common from "./common/commonReducer";
import orgDetails from "./orgDetails/orgDetailsReducer";
import materialityAssessment from "./materialityAssessment/matAssessmentReducer";
import supplierAssessment from "./supplierAssessment/supplierAssessmentReducer";
import surveyReducer from "./survey/surveyReducer";
import supplierAdminReducer from "./supplierAdmin/supplierAdminReducer";
import riskAdminReducer from "./riskAdmin/riskAdminReducer";
import esgStrategyPlanning from "./esgStrategyPlanning/esgStrategyPlanningReducer";
import esgMaturity from "./esgMaturity/esgMaturityReducer";
import frameWorV3 from "./frameWork/frameWorkReducer";

// task
import materialityTask from "./task/materialityTaskReducer/materialityTaskReducer";
import maturityTask from "./task/maturityTaskReducer/maturityTaskReducer";
import esgStrategyTask from "./task/esgStrategyPlanning/esgStrategyPlanningTaskReducer";
import esgComplianceTask from "./task/esgCompliance/esgComplianceTaskReducer";

import gptWise from "./gptWise/gptWiseReducer";
import chatTimers from "./chatTimers/chatTimersReducer";
import escCompliance from "./esgCompliance/esgComplianceReducer";

import thread from "./thread/threadReducer";
import dataset from "./datahub/datasetReducer";
import dataHub from "./datahubOuter/datahubReducer";
import customFrameworksReducer from "./customFrameworks/customFrameworksReducer";
import questionSetReducer from "./questionSet/questionSetReducer";
// test
import test from "./test/testReducer";

import sid from "sid/reducers/sidReducer";

export default combineReducers({
  user,
  common,
  login,
  snackbar,
  loader,
  businessUnit,
  frameworks,
  topic,
  basicInfo,
  esgStrategy,
  fieldData,
  surveyListing,
  reportlisting,
  generalSettings,
  comments,
  loadingBar: loadingBarReducer,
  layout,
  orgDetails,
  materialityAssessment,
  esgStrategyPlanning,
  esgMaturity,
  materialityTask,
  maturityTask,
  esgStrategyTask,
  esgComplianceTask,
  gptWise,
  chatTimers,
  frameWorV3,
  dataHub,
  escCompliance,
  thread,
  test,
  dataset,
  supplierAssessment,
  surveyReducer,
  supplierAdminReducer,
  riskAdminReducer,
  customFrameworksReducer,
  questionSetReducer,
  sid,
});
